module.exports = __webpack_public_path__ + "static/media/behance-web.a73fb2a0.svg";